import { render } from "./ProductButtonsPlaceholders.vue?vue&type=template&id=9e168a50&scoped=true"
import script from "./ProductButtonsPlaceholders.vue?vue&type=script&lang=js"
export * from "./ProductButtonsPlaceholders.vue?vue&type=script&lang=js"

import "./ProductButtonsPlaceholders.vue?vue&type=style&index=0&id=9e168a50&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e168a50"]])

export default __exports__